import { FormattedMessage } from 'react-intl';
import Spinner from '@/shared/components/Spinner';

export default function SchedulesLoadingState() {
  return (
    <div
      className="flex items-center justify-center gap-2 p-6 text-sm text-slate-500"
      aria-busy="true"
      aria-live="polite"
    >
      <Spinner className="h-4 w-4" />
      <FormattedMessage id="accounts.card.loadingSchedules" />
    </div>
  );
}
